import './Utils/Styles/index.scss';
import './Utils/Styles/mixins.scss';
import React from 'react';
import { Provider } from 'react-redux';
import { Store } from './store';
import {render} from 'react-dom';
import { routes } from './router';
import 'bulma/css/bulma.css';
import { addSavedDataToDropelements, get_all_drops } from './Services/Drop/action';


let dropelements = localStorage.getItem('dropelements-weland');

function isJson(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

if(dropelements !== null)
{
	if(isJson(dropelements))
	{
		Store.dispatch(addSavedDataToDropelements(JSON.parse(dropelements)));
	}
}
if(dropelements === null)
{
	Store.dispatch(get_all_drops(196));
}
render((
	<Provider store={Store}>
		{routes}
	</Provider>), document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js